import { reducerRegistry } from '../../../../reducerRegistry';

import statesReducersMap from './states/reducersMap';

const combineMap = {
  states: statesReducersMap
};

export default function combineRegistry() {
  reducerRegistry.registerByCombineMap('main', combineMap);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/main/reducers/static/combineRegistry.js